module.exports = __webpack_public_path__ + "img/specials-multislider-6040--nissan.11e0b274.jpeg";